import { formatStorageHours } from '@lib/utils/units';
import { billingStore } from '@stores/Billing';
import { observer } from 'mobx-react-lite';
import css from './Usage.module.scss';
import { UsageBar } from './UsageBar';

/** Hours of media the account holds against its plan's limit. A standing total, not a monthly quota. */
export const StorageUsage = observer(() => {
  // `storageLeft` reads a missing limit as 0 left, which would render a full bar.
  if (!billingStore.data?.limits || !billingStore.data?.usage) return null;
  const used = billingStore.storageUsageSeconds;
  const left = billingStore.storageLeft;

  return (
    <div className={css.usageSection}>
      <div className={css.header}>
        <span className={css.title}>Media storage</span>
        <span className={css.figures}>
          {formatStorageHours(used)} of {formatStorageHours(used + left)} used
        </span>
      </div>
      <UsageBar
        height={12}
        segments={[
          {
            label: 'Used',
            color: '#f58964',
            value: used,
            tooltipText: `${formatStorageHours(used)} used`,
          },
          {
            label: 'Free',
            color: 'transparent',
            value: left,
            tooltipText: `${formatStorageHours(left)} free`,
          },
        ]}
      />
    </div>
  );
});
